export type { FaqItem, FaqStatus } from '../../types/Endpoints/faq/FaqContracts';

export enum PageStatus {
    MAIN = 'MAIN',
    ADD = 'ADD',
    EDIT = 'EDIT',
}

export type FaqFilterKey = 'categoryId' | 'oftenSearchedId';

export type FaqParentProps = {
    categoryId?: number;
    oftenSearchedId?: number;
};

export const MAX_ACTIVE_FAQ_COUNT = 10;
